<template>
  <b-list-group-item style="padding-top: 2px;padding-bottom: 2px;padding-left: 0;padding-right: 0;border:0">
    <b-row no-gutters>
      <b-col md="4" sm="12">
        {{this.initialValue.descripcio}}
      </b-col>
      <b-col md="4" sm="12">
          <b-row no-gutters>
            <b-col md="4">        
              <b-badge variant="light"><b-icon icon="flag-fill" class="mr-2"></b-icon>
                <template v-if="this.initialValue.percMinRespostes>0">      
                  {{ this.initialValue.percMinRespostes}}%
                </template>
                <template v-if="this.initialValue.numMinRespostes>0">      
                  {{ this.initialValue.numMinRespostes}} 
                </template>                
              </b-badge>
            </b-col>
            <b-col md="8" v-if='this.mode=="consultar"'>        
                <b-progress v-if='this.initialValue.numMinRespostes!=null && this.initialValue.numMinRespostes>0' :max="this.initialValue.totalEnquestats"  show-value >
                  <b-progress-bar :value="this.initialValue.numActualRespostes" :variant='this.initialValue.numMinRespostes>this.initialValue.numActualRespostes?"danger":"success"'></b-progress-bar>
                </b-progress>
                <b-progress v-if='this.initialValue.percMinRespostes!=null && this.initialValue.percMinRespostes>0' max="100"  show-value >
                  <b-progress-bar :value="this.initialValue.percActualRespostes" :variant='this.initialValue.percMinRespostes>this.initialValue.percActualRespostes?"danger":"success"'></b-progress-bar>
                </b-progress>
            </b-col>            
          </b-row>                 
      </b-col>
                  
      <b-col md="4" sm="12" class="btn-group-quota">
        <b-button-group size="sm" v-if='this.mode=="editar"'>
          <b-button size="sm" variant="outline-primary" @click="onEditarQuotaEnquesta()">
          <b-icon icon="pencil" aria-label="Editar"></b-icon>
          </b-button>
          <b-button size="sm" variant="outline-primary" @click="onEliminarQuotaEnquesta()">
          <b-icon icon="trash" aria-label="Eliminar"></b-icon>
          </b-button>
        </b-button-group>
        <b-button-group size="sm" v-if='this.mode=="consultar"'>
          <b-button  v-if='((this.initialValue.percMinRespostes!=null && this.initialValue.percMinRespostes>0 && this.initialValue.percActualRespostes>=this.initialValue.percMinRespostes) || (this.initialValue.numMinRespostes!=null && this.initialValue.numMinRespostes>0 ))' size="sm" variant="outline-primary" @click="onConsultarResultats()">
            <b-icon icon="graph-up" aria-label="Resultats"></b-icon>
          </b-button>
          <b-button v-if='((this.initialValue.percMinRespostes!=null && this.initialValue.percMinRespostes>0 && this.initialValue.percActualRespostes>=this.initialValue.percMinRespostes) || (this.initialValue.numMinRespostes!=null && this.initialValue.numMinRespostes>0 ))' size="sm" variant="outline-primary" @click="onExportarResultats()">
            <b-icon icon="download" aria-label="Export"></b-icon>
          </b-button>
        </b-button-group>
      </b-col>                   
    </b-row>
  </b-list-group-item>
</template>

<script>
export default {
  name: "ItemQuota",
  props: {    
     initialValue:{      
     type: Object,
     required: true
    },
    mode:{      
     type: String,
     required: true
    }    
  },   
  data() {
    return {quota: {}};
  },
  computed:{

  },   
  methods: {    
    onEditarQuotaEnquesta(){       
      this.$emit('editar-quota', this.initialValue);
    },  
    onEliminarQuotaEnquesta(){       
      this.$emit('eliminar-quota', this.initialValue);
    },  
    onConsultarResultats(){ 
      let q = {};
      q.idQuota = this.initialValue.idQuota;
      let e = {};
      e.quotes = []
      e.quotes.push(q);      
      let filtres = [];
      filtres.push(e);
      let cerca = {};
      cerca.filtres = filtres;      
      this.$emit('consultar-resultats', cerca);
    },
    onExportarResultats(){
      let c = {};
      c.idQuota = this.initialValue.idQuota;        
      this.$emit('exportar-resultats', c);
    }     
  },
  mounted() {
    if(this.initialValue!=null){
      this.quota = this.initialValue;
    }   
  }
};
</script>

<style>
.btn-group-quota{
  text-align: right;
}
.label-quota{
  font-weight: 500;
  font-size: 14px;
}
</style>